import styled from 'astroturf/react'
import { parseISOToDateTime, diff } from '@calendly/datetime'
import { useSelector } from 'react-redux'
import { EventLocation, Duration } from '@calendly/booking-kit'
import { Loader } from '@calendly/ui/components/loader'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { useFlag } from '@calendly/feature-check-react'

import PaymentSummary from 'components/payment/summary'
import { timeNotationSelector, eventSelector } from 'selectors'
import { chargeSelector } from 'selectors/payment'
import { useInvitee } from 'components/use_invitee'
import ErrorAlert from 'components/error/alert'
import Profile from 'components/profile'
import EventTime from 'components/details/event_time'
import Timezone from 'components/details/timezone'

import { Wrapper } from './components/wrapper'
import { Publisher } from './components/publisher'
import { Attendees } from './components/attendees'
import _Payment from "details-Payment.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/details.js?styleId=Payment";
import _StyledWrapper from "details-StyledWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/details.js?styleId=StyledWrapper";


const Payment = /*#__PURE__*/styled(PaymentSummary, null, {
  displayName: "Payment",
  styles: _Payment
})

const StyledWrapper = /*#__PURE__*/styled(Wrapper, null, {
  displayName: "StyledWrapper",
  styles: _StyledWrapper
})

export const Details = () => {
  const event = useSelector(eventSelector)
  const timeNotation = useSelector(timeNotationSelector)
  const invitee = useInvitee()
  const charge = useSelector(chargeSelector)
  const isPhone = useDeviceType('isPhone')
  const bookingAppRedesign = useFlag('booking_app_redesign', false)

  if (event === undefined || invitee === undefined) return <Loader />

  if (event === null || invitee === null) {
    return (
      <ErrorAlert
        error={{}}
        buttonClick={() => window.location.reload()}
      />
    )
  }

  const {
    name, guests, scheduled_profile: scheduledProfile
  } = event

  const { timezone, email } = invitee

  const duration = diff(parseISOToDateTime(event.end_time), parseISOToDateTime(event.start_time), 'minutes')

  return (
    <div>
      <Profile
        reduced
        avatar={scheduledProfile.avatar_url}
        logoUrl={scheduledProfile.logo_url}
        name={scheduledProfile.name}
        eventTypeName={name}
      />
      <StyledWrapper>
        {isPhone && <Publisher name={scheduledProfile.name} bookingAppRedesign={bookingAppRedesign} />}
        <Duration value={duration} />
        <EventTime
          source={event}
          timezone={timezone}
          timeNotation={timeNotation}
          bookingAppRedesign={bookingAppRedesign}
        />
        <Timezone value={timezone} bookingAppRedesign={bookingAppRedesign} />
        <EventLocation event={event} iconSize={bookingAppRedesign ? 'standard' : 'large'} />
        <Attendees items={[email, ...guests]} bookingAppRedesign={bookingAppRedesign} />
      </StyledWrapper>
      <Payment charge={charge} />
    </div>
  )
}
